import { render, staticRenderFns } from "./EventPrices.vue?vue&type=template&id=ab98c852&scoped=true&"
import script from "./EventPrices.vue?vue&type=script&lang=js&"
export * from "./EventPrices.vue?vue&type=script&lang=js&"
import style0 from "./EventPrices.vue?vue&type=style&index=0&id=ab98c852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab98c852",
  null
  
)

export default component.exports